export default {
  name: "media",
  methods: {
    // Listens and sets matching data property true/false for size
    checkMediaQuery: function () {
      this.lessThan1699 = window.matchMedia("(max-width: 1699px)").matches;
      this.lessThan1199 = window.matchMedia("(max-width: 1199px)").matches;
      this.lessThan1099 = window.matchMedia("(max-width: 1099px)").matches;
      this.lessThan974 = window.matchMedia("(max-width: 974px)").matches;
      this.lessThan949 = window.matchMedia("(max-width: 949px)").matches;
      this.lessThan899 = window.matchMedia("(max-width: 899px").matches;
      this.lessThan724 = window.matchMedia("(max-width: 724px)").matches;
      this.lessThan599 = window.matchMedia("(max-width: 599px)").matches;
      this.lessThan499 = window.matchMedia("(max-width: 499px)").matches;
    },
  },
  mounted() {
    window.addEventListener("resize", this.checkMediaQuery);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMediaQuery);
  },
};
